import(/* webpackMode: "eager" */ "/home/ec2-user/ennix-electronics/src/app/warranty/loading.js");
